import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const SoundMaxIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('SoundMaxIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 17"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.375 6.475A3.33 3.33 0 0 1 12.05 8.5a3.33 3.33 0 0 1-.675 2.025m2.025-5.4c.844.922 1.35 2.096 1.35 3.375s-.506 2.453-1.35 3.375M4.625 6.137H2.6a1.35 1.35 0 0 0-1.35 1.35v2.025c0 .746.604 1.35 1.35 1.35h2.025L9.35 13.9V3.1z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
SoundMaxIcon.id = 'SoundMaxIcon';
SoundMaxIcon.displayName = 'SoundMaxIcon';
export default SoundMaxIcon;
